import {EGeoType} from "./IconService";
import {Feature} from "ol";
import {Geometry} from "ol/geom";
import {GeoJSON} from "ol/format";

export default class VDService {

    kommunenr: number | undefined = undefined;

    constructor(kommunenr: number) {
        this.kommunenr = kommunenr;
    }

    public async getFeatures<TResponse>(type?: EGeoType, fields?: string[]): Promise<TResponse> {

        let queryString = 'http://localhost:8888/geoserver/geopark/' +
            'ows?service=WFS&version=1.0.0&request=GetFeature&' +
            'typeName=geopark%3Ageopark&maxFeatures=50&outputFormat=application%2Fjson';

        return fetch(queryString)
            .then((resp) => resp.json())
            .then((data) => {

                // Doing this by a query did not work, so we filter old school
                const rawFeatures: Feature<Geometry>[] = new GeoJSON().readFeatures(data, {
                    featureProjection: 'EPSG:3857'
                });
                const ftrs: Feature<Geometry>[] = []
                rawFeatures.forEach((f) => {
                    //if (f.getProperties() == 1) {);
                    ftrs.push(f);
                    //}
                });

                return ftrs as TResponse;
            })
            .catch(e => {
                return Promise.reject({
                    status: e.status,
                    ok: false,
                    message: e.json,
                    body: e.json
                });
            });

    }
}
